import { CalendarX2Icon } from 'lucide-react';
import Balancer from 'react-wrap-balancer';

import { Box } from '@eluve/components';

interface CancelledAppointmentDisplayProps {
  message?: string;
  iconSize?: number;
  className?: string;
}

export const CancelledAppointmentDisplay: React.FC<
  CancelledAppointmentDisplayProps
> = ({
  message = 'This appointment was canceled in your EHR.',
  iconSize = 96,
  className,
}) => {
  return (
    <Box vStack center fullWidth className={`gap-12 p-2 ${className || ''}`}>
      <CalendarX2Icon size={iconSize} className="text-border-tertiary" />
      <h3 className="text-center text-xl">
        <Balancer>{message}</Balancer>
      </h3>
    </Box>
  );
};
